import { create } from 'zustand';

const initialState = {
  filledWithAI: false,
  saveEdition: false,
  responseData: [],
  tempEditFeedback: [],
  isLoading: false,
};

export const useAutoratingStore = create((set, get) => ({
  ...initialState,
  setFilledWithAI: () => set(() => ({ filledWithAI: true })),
  setResponseData: (responseData = []) => set(() => ({ responseData })),
  setTempEditFeedback: (tempEditFeedback = []) => set(() => ({ tempEditFeedback })),
  setSaveEdition: () => set(() => ({ saveEdition: true })),
  editRemark: ({ id, id_fdbk, comment }) =>
    set((state) => {
      return {
        tempEditFeedback: state.tempEditFeedback.map((item) =>
          item.id_question === id && item.id_feedback === id_fdbk
            ? {
                ...item,
                answer: {
                  ...item.answer,
                  remarks: comment,
                },
              }
            : item
        ),
      };
    }),
  editRating: ({ id, id_fdbk, rating }) =>
    set((state) => {
      return {
        tempEditFeedback: state.tempEditFeedback.map((item) =>
          item.id_question === id && item.id_feedback === id_fdbk
            ? {
                ...item,
                answer: {
                  ...item.answer,
                  rating,
                },
              }
            : item
        ),
      };
    }),
  deleteItem: ({ id, id_fdbk }) =>
    set((state) => ({
      tempEditFeedback: state.tempEditFeedback.filter(
        (item) => !(item.id_question === id && item.id_feedback === id_fdbk)
      ),
    })),
  reset: () => {
    set(initialState);
  },
  setIsLoading: (isLoading) => set(() => ({ isLoading })),
}));
